/**
 * 统一 UA 规则（客户端/服务端可复用）
 */
export const MOBILE_UA_REGEX = /(iPhone|Android|SymbianOS|Windows Phone|iPod)/i;

export function isRealMobileUserAgent(ua: string | undefined | null): boolean {
  return MOBILE_UA_REGEX.test(ua || '');
}
